import Text from 'components/Text/Text';
import React, { useContext, useEffect } from 'react';
import { Form } from 'antd';
import BtnBlock from './components/BtnBlock';
import NameField from './components/NameField';
import ModalWindows from './components/ModalWindows';
import {
	CreateVideoStudioContext,
	ICreateVideoStudioContext,
} from './createVideoStudioModalContext/createVideoStudioModalState/createVideoStudioModalContext';
import { preventDefaultForEnterKey } from 'utils/helpers';
import classNames from 'classnames';
import style from './CreateVideoStudioModal.module.scss';

interface ICreateDeveloperModal {
	isVisible: boolean;
}

const CreateVideoStudioModal: React.FC<ICreateDeveloperModal> = ({ isVisible }) => {
	const { setDataForSubmit, changeTypeOfModalWindow, changeName, name } =
		useContext<ICreateVideoStudioContext>(CreateVideoStudioContext);

	const containerClasses = classNames(style.container, { [style.visible]: isVisible });

	const [form] = Form.useForm();

	useEffect(() => {
		form.setFieldsValue({ name });
	}, [name]);

	const submit = () => {
		setDataForSubmit({
			name,
		});
		changeTypeOfModalWindow('toConfirmSubmit');
	};

	return (
		<div className={containerClasses} data-test="CreateVideoStudioModal">
			<Form form={form} name="basic" onFinish={submit} onKeyPress={preventDefaultForEnterKey} layout="vertical">
				<div className={style.wrapper}>
					<div className={style.content}>
						<Text
							className={style.heading}
							translationNameSpace="form"
							translationKey="creatingVideoStudioHeading"
							size="xxl"
							weight="bold"
						/>
						<NameField changeName={changeName} />
					</div>
					<BtnBlock />
				</div>
			</Form>
			<ModalWindows />
		</div>
	);
};

export default React.memo(CreateVideoStudioModal);
